import React, { Component } from 'react';
import {
  Box,
  Card,
  CardBody,
  Flex,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  CardHeader,
  Text,
  Thead,
  Tr,
  Th,
  Icon,
  Tbody,
  Td,
  TableContainer,
  Divider,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Heading,
  Button,
} from '@chakra-ui/react';
import {
  FaArrowDown,
  FaArrowUp,
  FaCashRegister,
  FaDollarSign,
  FaDownload,
  FaList,
  FaPercentage,
} from 'react-icons/fa';

import 'rsuite/dist/rsuite.css';
import { IconButton, Table } from 'rsuite';
import '../costs/pltable.css';
import ModalHeader from 'rsuite/esm/Modal/ModalHeader';
import { fetchWithAuth } from '../../../utils/apiHelpers';
import { createRef } from 'react';
import { DownloadTableExcel, downloadExcel } from 'react-export-table-to-excel';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Pagination from '../../utility/pagination';

class PLSummary extends Component {
  state = {
    transactions: undefined,
    transactionsLoader: false,
    isTree: true,
    MisOpen: false,
    pltable: [],
    pltableMini: [],
    columnsMini: [],
    recordsPerPage: 100,
    totalRecords: 100,
    activePage: 1,
  };

  fetchTransactions = accountKey => {
    console.log(
      '=== fetchTransactions called ===',
      '\nTimestamp:',
      new Date().toISOString(),
      '\naccountKey:',
      accountKey,
      '\nactivePage:',
      this.state.activePage,
      '\nStack trace:'
    );
    console.trace();
    this.setState({
      transactionsLoader: true,
      transactions: undefined,
      totalRecords: undefined,
    });
    var formDat = new FormData();
    console.log('from_date:', this.props.from_date);
    formDat.append('accountKey', accountKey);
    formDat.append('fromDate', this.props.from_date);
    formDat.append('toDate', this.props.to_date);
    formDat.append('location', this.props.locationValue);
    formDat.append('activePage', this.state.activePage);
    formDat.append('recordsPerPage', this.state.recordsPerPage);
    console.log('Sending activePage to API:', this.state.activePage);
    if (this.props.periodSelect) {
      formDat.append('periodFrom', this.props.periodFrom);
      formDat.append('periodTo', this.props.periodTo);
    }

    fetchWithAuth('/api/get_transactions/', {
      method: 'POST',
      body: formDat,
    })
      .then(response => response.json())
      .then(data => {
        console.log('API Response received:', data);
        console.log('Transactions data:', data.transactions);
        console.log(
          'Transactions data array length:',
          data.transactions?.data?.length
        );
        this.setState(
          {
            transactions: data.transactions,
            transactionsLoader: false,
            totalRecords: data.totalRecords.total_rows,
          },
          () => {
            console.log(
              'State updated. Current transactions:',
              this.state.transactions
            );
            console.log('Current activePage:', this.state.activePage);
          }
        );
      })
      .catch(err => console.error('Error fetching transactions:', err));
    this.setState({ MisOpen: true });
  };
  // Sort data functions
  getData = () => {
    if (this.state.sortColumn && this.state.sortType) {
      this.setState({
        testTable: this.state.testTable.sort((a, b) => {
          let x = a[this.state.sortColumn];
          let y = b[this.state.sortColumn];
          if (typeof x === 'string') {
            x = x.charCodeAt();
          }
          if (typeof y === 'string') {
            y = y.charCodeAt();
          }
          if (this.state.sortType === 'asc') {
            return x - y;
          } else {
            return y - x;
          }
        }),
      });
    }
  };

  handleSortColumn = (sortColumn, sortType) => {
    this.setState({ loading: true, isTree: false });
    setTimeout(() => {
      this.setState(
        {
          loading: false,
          sortColumn: sortColumn,
          sortType: sortType,
          isTree: true,
        },
        () => {
          this.getData();
        }
      );
    }, 500);
  };

  trim(str) {
    if (!str) return str;
    return str.replace(/^\s+/g, '');
  }

  handleDownloadExcel = () => {
    downloadExcel({
      fileName: 'PL Summary',
      sheet: 'summary',
      tablePayload: {
        header: [
          'Description',
          'Current year (' + this.props.columnCurrency + ')',
          'Previous year (' + this.props.columnCurrency + ')',
          'Change (' + this.props.columnCurrency + ')',
          'Percent Change (%)',
        ],
        body: this.props.tableData,
      },
    });
  };

  tableRef = createRef();
  componentDidMount = () => {
    this.setState({ tableData: this.props.tableData });
  };

  render() {
    const { Column, HeaderCell, Cell } = Table;
    return (
      <Card width={'100%'}>
        <Modal
          isOpen={this.state.MisOpen}
          onClose={() => {
            this.setState({ MisOpen: false, activePage: 1 });
          }}
          size={'5xl'}
        >
          <ModalOverlay />
          <ModalContent position={'fixed'}>
            <ModalHeader>
              <Heading size={'md'} m={3}>
                Transactions for {this.state.desc}
              </Heading>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Table
                className="custom-table"
                rowHeight={() => 20}
                height={window.innerHeight * 0.7}
                data={
                  this.state.transactions !== undefined
                    ? this.state.transactions['data'].map((row, index) => ({
                        ...row,
                        _rowKey: `${this.state.activePage}-${index}`,
                      }))
                    : []
                }
                rowKey="_rowKey"
                loading={this.state.transactionsLoader}
                hover
                wordWrap={'break-all'}
                virtualized
                bordered
                cellBordered
              >
                {this.state.transactions !== undefined ? (
                  this.state.transactions.columns.map(item => (
                    <Column resizable>
                      <HeaderCell>
                        {item.value === 'tx_date' ? 'Date' : item.value}
                      </HeaderCell>
                      <Cell dataKey={item.key}>
                        {rowData => (
                          <Text fontSize={'xxs'} align={'center'}>
                            {rowData[item.key]}
                          </Text>
                        )}
                      </Cell>
                    </Column>
                  ))
                ) : (
                  <></>
                )}
              </Table>
              <Flex width={'100%'} justifyContent={'center'}>
                {/*<Pagination
                prev
                last
                next
                first
                size="sm"
                total={this.state.totalRecords}
                limit={this.state.recordsPerPage}
                activePage={this.state.activePage}
                onChangePage={(pageNumber)=>this.setState({activePage:pageNumber}, ()=>{
 
                  this.fetchTransactions(this.state.accountKey)
                })}
              />*/}
                {this.state.totalRecords !== undefined ? (
                  <Pagination
                    previousPage={() => {
                      console.log('prev page cliked');
                      console.log(this.state.activePage);
                      if (this.state.activePage > 1) {
                        this.setState(
                          { activePage: parseInt(this.state.activePage) - 1 },
                          () => {
                            this.fetchTransactions(this.state.accountKey);
                          }
                        );
                      }
                    }}
                    nextPage={() => {
                      if (
                        this.state.activePage <
                        parseInt(
                          this.state.totalRecords / this.state.recordsPerPage
                        ) +
                          1
                      ) {
                        this.setState(
                          { activePage: parseInt(this.state.activePage) + 1 },
                          () => {
                            this.fetchTransactions(this.state.accountKey);
                          }
                        );
                      }
                    }}
                    activePage={this.state.activePage}
                    of={
                      parseInt(this.state.totalRecords) > 0
                        ? parseInt(
                            this.state.totalRecords / this.state.recordsPerPage
                          ) + 1
                        : 0
                    }
                    onChange={value => {
                      console.log(value);
                      this.setState({ activePage: value }, () => {
                        this.fetchTransactions(this.state.accountKey);
                      });
                    }}
                  />
                ) : (
                  <></>
                )}
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                onClick={() => {
                  this.setState({ MisOpen: !this.state.MisOpen });
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <CardHeader>
          <Flex>
            <Flex gap={2} flex={1} alignItems={'center'} width={'100%'}>
              <Icon as={FaList} />
              <Text fontSize={'md'}>P&L</Text>
            </Flex>
            <Flex flex={1} justifyContent={'flex-end'}>
              <IconButton
                as={Button}
                icon={<FaDownload />}
                onClick={this.handleDownloadExcel}
              />
            </Flex>
          </Flex>
        </CardHeader>
        <Divider mt={0} />
        <CardBody overflowX={'scroll'} fontSize={'sm'}>
          <Table
            isTree={this.state.isTree}
            defaultExpandAllRows
            rowHeight={rowData => {
              if (rowData !== undefined) {
                if (
                  rowData.account_key === '-' ||
                  rowData.account_key === null ||
                  rowData.account_key === ''
                ) {
                  return 25;
                } else {
                  return 25;
                }
              }
            }}
            rowKey="index_ui"
            height={400}
            data={this.props.pltable}
            shouldUpdateScroll={false}
            //sortColumn={this.state.sortColumn}
            sortType={this.state.sortType}
            onSortColumn={this.handleSortColumn}
            loading={this.props.pltable !== undefined ? false : true}
            className="custom-table"
            hover
            wordWrap={'break-word'}
            verticalAlign={'middle'}
          >
            <Column width={100} flexGrow={1} resizable>
              <HeaderCell>Description</HeaderCell>
              <Cell dataKey="desc">
                {rowData =>
                  rowData.account_key === '-' ||
                  rowData.account_key === null ||
                  rowData.account_key === '' ? (
                    <strong style={{ fontSize: '12px' }}>
                      {this.trim(rowData.desc)}
                    </strong>
                  ) : (
                    <Button
                      justifyContent={'left'}
                      alignItems={'flex-start'}
                      variant={
                        rowData.desc !== this.props.highlightDesc
                          ? 'ghost'
                          : 'solid'
                      }
                      as={
                        rowData.desc !== this.props.highlightDesc
                          ? Link
                          : Button
                      }
                      onClick={() => {
                        this.fetchTransactions(rowData.account_key);
                        this.setState({
                          accountKey: rowData.account_key,
                          desc: rowData.desc,
                        });
                      }}
                      colorScheme={
                        rowData.desc === this.props.highlightDesc
                          ? 'yellow'
                          : 'blue'
                      }
                      //width={'100%'}
                      //position={rowData.desc===this.props.highlightDesc?"fixed":'inherit'}
                      borderRadius={0}
                      fontSize={'12px'}
                    >
                      {rowData.desc}
                    </Button>
                  )
                }
              </Cell>
            </Column>
            <Column width={100} flexGrow={1}>
              <HeaderCell align={'center'}>
                Current year ({this.props.columnCurrency})
              </HeaderCell>
              <Cell dataKey="subt_nat_amount_x">
                {rowData => (
                  <Text align={'center'}>
                    {rowData.subt_nat_amount_x !== null
                      ? rowData.subt_nat_amount_x
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      : ''}
                  </Text>
                )}
              </Cell>
            </Column>
            <Column width={100} flexGrow={1}>
              <HeaderCell align={'center'}>
                Previous year ({this.props.columnCurrency})
              </HeaderCell>
              <Cell dataKey="subt_nat_amount_y">
                {rowData => (
                  <Text align={'center'}>
                    {rowData.subt_nat_amount_y !== null
                      ? rowData.subt_nat_amount_y
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      : ''}
                  </Text>
                )}
              </Cell>
            </Column>
            <Column width={100} flexGrow={1}>
              <HeaderCell align={'center'}>
                Change ({this.props.columnCurrency})
              </HeaderCell>
              <Cell dataKey="change">
                {rowData => (
                  <Text
                    align={'center'}
                    color={
                      (rowData.per_change < 0) &
                        (rowData.classification === 'Revenue') ||
                      (rowData.per_change > 0) &
                        (rowData.classification === 'Expense')
                        ? 'red'
                        : 'green'
                    }
                  >
                    {rowData.change !== null
                      ? rowData.change
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      : ''}
                  </Text>
                )}
              </Cell>
            </Column>
            <Column width={100} flexGrow={1}>
              <HeaderCell align={'center'}>Percent Change (%)</HeaderCell>
              <Cell dataKey="per_change">
                {rowData => (
                  <Text
                    align={'center'}
                    color={
                      (rowData.per_change < 0) &
                        (rowData.classification === 'Revenue') ||
                      (rowData.per_change > 0) &
                        (rowData.classification === 'Expense')
                        ? 'red'
                        : 'green'
                    }
                  >
                    {rowData.per_change}
                  </Text>
                )}
              </Cell>
            </Column>
          </Table>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  return {
    columnCurrency: state.locationSelectFormat.currency,
    periodFrom: state.dateFormat.periodFrom,
    periodTo: state.dateFormat.periodTo,
    periodSelect: state.dateFormat.periodSelect,
  };
};

export default connect(mapStateToProps)(PLSummary);
